import React, { FC, useEffect } from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import config from './config'
import utils from '../../../../../components/Organisms/Form/utils'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'

import { FormProps } from '../../../../Pages/Onboarding/types'

const LegalEntityIdentifierForm: FC<FormProps> = props => {
  const submitForm = ({data, options}: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit({ data, options })
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
    configData,
  } = useForm(
    props.fetchedData,
    config,
    submitForm
  )

  useEffect(() => {
    toggleShowByName(
      'leiNumber',
      formData?.eLEIStatus?.value === 'haveLEI'
    )
  }, [formData?.eLEIStatus?.value])

  useEffect(() => {
    toggleShowByName(
      'parentLEINumber',
      formData?.doYouHaveParentCompany?.value === 'true'
    )
  }, [formData?.doYouHaveParentCompany?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.title')}
        </FormTitle>
        <FormDescription>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.LegalEntityIdentifierForm.description' />
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default LegalEntityIdentifierForm
